<template>
    <div>
        <slot v-if="activeContent[0]" name="content0"/>
        <slot v-if="activeContent[1]" name="content1"/>
        <slot v-if="activeContent[2]" name="content2"/>
        <slot v-if="activeContent[3]" name="content3"/>
        <slot v-if="activeContent[4]" name="content4"/>
        <slot v-if="activeContent[5]" name="content5"/>
        <slot v-if="activeContent[6]" name="content6"/>
        <slot v-if="activeContent[7]" name="content7"/>
        <slot v-if="activeContent[8]" name="content8"/>
        <slot v-if="activeContent[9]" name="content9"/>
    </div>
</template>

<script>
import { mapState } from "vuex"
const contentFactory = () => ({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
})

export default {
    name: "DynamicContent",
    props: {
        testingType: {
            type: String,
            default: "personalization"
        },
        content: {
            default: () => [],
        }
    },
    data:() => ({
        activeContent: contentFactory(),
    }),
    watch: {
        meta(value, oldValue){
            if (value !== oldValue){
                this.updateActiveContent()
            }
        }
    },
    mounted() {
        this.updateActiveContent()
    },
    computed: {
        ...mapState([
            'meta',
            'businessOffers',
        ]),
        parsedContent() {
            return JSON.parse(this.content)
        },
        zipcode(){
            return this.meta.postalCode
        },
        tier(){
            return this.businessOffers?  this.businessOffers.name: null
        },
        marketType(){
            return this.meta.marketType
        },
    },
    methods: {
        resetActiveContent(){
            this.activeContent = contentFactory()
        },
        updateActiveContent(){
            const variation = this.parsedContent

            for (let i in variation) {
                const audience = variation[i].audience

                if(!audience){
                    this.activeContent[i] = false
                }

                const zipcodes    = audience.zipcodes? audience.zipcodes.replace(/\s/g,'').split(','): null
                const tier        = audience.tier? audience.tier.split(','): null
                const marketType  = audience.marketType? audience.marketType.split(','): null
                const query       = audience.query
                const queryValue  = audience.queryValue? audience.queryValue: ''
                const queryString = window.location.search;

                if (zipcodes && this.zipcode && zipcodes.findIndex(i => i === this.zipcode.substring(0, 5)) >= 0){
                    this.resetActiveContent()
                    this.activeContent[i] = true
                } else if (tier && this.tier && tier.findIndex(i => i === this.tier) >= 0){
                    this.resetActiveContent()
                    this.activeContent[i] = true
                } else if (marketType && this.marketType && marketType.findIndex(i => i === this.marketType) >= 0){
                    this.resetActiveContent()
                    this.activeContent[i] = true
                } else if (query && new URLSearchParams(queryString).get(query)) {
                    if(queryValue === ''){
                        this.resetActiveContent()
                        this.activeContent[i] = true
                    } else {
                        const queryList = queryValue.replace(/\s/g,'').split(',')
                        for(let x in queryList){
                            let value = new URLSearchParams(queryString).get(query)
                            if (queryList[x] === value){
                                this.resetActiveContent()
                                this.activeContent[i] = true
                            }
                        }
                    }
                } else if (audience.isDefault) {
                    this.resetActiveContent()
                    this.activeContent[i] = true
                } else {
                    this.activeContent[i] = false
                }
            }
        },
    },

}
</script>

